import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeImageWrapperSkeleton } from './TypeImageWrapper';

export interface TypeBlockLogoGridFields {
    internalName: EntryFieldTypes.Symbol;
    logos: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeImageWrapperSkeleton>>;
    logosCloudinary?: EntryFieldTypes.Object;
    isFullBleed?: EntryFieldTypes.Boolean;
    iconStyle?: EntryFieldTypes.Symbol<'grayscale'>;
}

export type TypeBlockLogoGridSkeleton = EntrySkeletonType<TypeBlockLogoGridFields, 'blockLogoGrid'>;
export type TypeBlockLogoGrid<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockLogoGridSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockLogoGrid<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockLogoGrid<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockLogoGrid';
}
